var map = {
	"./$PAC.svg": "6f70",
	"./1ST.svg": "06fa",
	"./ABT.svg": "98fc",
	"./ABYSS.svg": "ba88",
	"./ACT.svg": "c40c",
	"./ACTN.svg": "e615",
	"./ADA-alt.svg": "33e5",
	"./ADA.svg": "12a4",
	"./ADC-alt.svg": "2230",
	"./ADC.svg": "4a38",
	"./AE.svg": "997f",
	"./AEON-alt.svg": "a7eb",
	"./AEON.svg": "80ee",
	"./AGI.svg": "9e73",
	"./AGRS.svg": "7ba9",
	"./AION.svg": "15c7",
	"./AMB.svg": "0a91",
	"./AMP-alt.svg": "00ba",
	"./AMP.svg": "a093",
	"./ANC-alt.svg": "8073",
	"./ANC.svg": "bcf7",
	"./ANT.svg": "d4b2",
	"./APEX.svg": "61d4",
	"./APPC.svg": "8a85",
	"./ARCH-alt.svg": "40e9",
	"./ARCH.svg": "2f23",
	"./ARDR-alt.svg": "67c5",
	"./ARDR.svg": "570c",
	"./ARG.svg": "133b",
	"./ARK-alt.svg": "bc6d",
	"./ARK.svg": "f6c2",
	"./ARN.svg": "1be6",
	"./ARY.svg": "b247",
	"./AST.svg": "94e8",
	"./ATL.svg": "a982",
	"./ATM.svg": "4650",
	"./AUR-alt.svg": "e805",
	"./AUR.svg": "c277",
	"./AUTO.svg": "821e",
	"./BANX-alt.svg": "0d23",
	"./BANX.svg": "ae89",
	"./BAT-alt.svg": "8699",
	"./BAT.svg": "81da",
	"./BAY-alt.svg": "0226",
	"./BAY.svg": "2bdc",
	"./BBO.svg": "70c4",
	"./BC-alt.svg": "48d7",
	"./BC.svg": "0ad1",
	"./BCBC.svg": "e6c7",
	"./BCC.svg": "35de",
	"./BCD.svg": "0d8a",
	"./BCH-alt.svg": "74d9",
	"./BCH.svg": "8157",
	"./BCHABC.svg": "0212",
	"./BCHSV.svg": "c330",
	"./BCN-alt.svg": "ec91",
	"./BCN.svg": "ebc62",
	"./BCO.svg": "a0c6",
	"./BCPT.svg": "c5b3",
	"./BCY.svg": "7a2f",
	"./BDL.svg": "92a4",
	"./BELA.svg": "0c06",
	"./BETR.svg": "6c46",
	"./BFT-alt.svg": "0fdd",
	"./BFT.svg": "01fc",
	"./BIX.svg": "7a3a",
	"./BKX.svg": "5e0d",
	"./BLCN.svg": "ba98",
	"./BLK.svg": "82ac",
	"./BLOCK.svg": "bdae",
	"./BLZ.svg": "f81a",
	"./BNB.svg": "0c2f",
	"./BNT.svg": "a37c",
	"./BNTY.svg": "fa33",
	"./BOS.svg": "4534",
	"./BPT.svg": "b741",
	"./BQ.svg": "d47e",
	"./BQX.svg": "59b2",
	"./BRD.svg": "43ff",
	"./BRK-alt.svg": "0646",
	"./BRK.svg": "5150",
	"./BRX-alt.svg": "ed8b",
	"./BRX.svg": "ca4a",
	"./BSD-alt.svg": "6261",
	"./BSD.svg": "ee7c",
	"./BTA.svg": "e98a",
	"./BTC-alt.svg": "011c",
	"./BTC.svg": "d3a8",
	"./BTCD-alt.svg": "9dc4",
	"./BTCD.svg": "a26a",
	"./BTCP-alt.svg": "6211",
	"./BTCP.svg": "d406",
	"./BTCZ.svg": "e80c",
	"./BTDX.svg": "d862",
	"./BTG.svg": "ee0f",
	"./BTM-alt.svg": "6828",
	"./BTM.svg": "8659",
	"./BTS-alt.svg": "8716",
	"./BTS.svg": "2657",
	"./BTT.svg": "56ca",
	"./BTX.svg": "6a80",
	"./BURST.svg": "a250",
	"./CALL.svg": "f6f7",
	"./CDN.svg": "8964",
	"./CDT.svg": "b64e",
	"./CENZ.svg": "dbf2",
	"./CFI.svg": "7d34",
	"./CHAT.svg": "ff79",
	"./CHF.svg": "5ee8",
	"./CHIPS.svg": "4685",
	"./CIX.svg": "a31d",
	"./CL.svg": "5242",
	"./CLAM-alt.svg": "6d16",
	"./CLAM.svg": "694e",
	"./CLOAK-alt.svg": "9c8e",
	"./CLOAK.svg": "d0ee",
	"./CMM.svg": "da59",
	"./CMT.svg": "1721",
	"./CND.svg": "07d8",
	"./CNX.svg": "89f5",
	"./CNY.svg": "9b1a",
	"./COB.svg": "41ab",
	"./COFI.svg": "644a",
	"./COLX.svg": "84f9",
	"./COQUI.svg": "278f",
	"./CRED.svg": "66b6",
	"./CRPT.svg": "34ed",
	"./CRW.svg": "9d89",
	"./CS.svg": "7e4d",
	"./CTR.svg": "e5b4",
	"./CTXC.svg": "847c",
	"./CVC-alt.svg": "711d",
	"./CVC.svg": "eb63",
	"./DAI.svg": "9b76",
	"./DAO-alt.svg": "cd1ca",
	"./DAO.svg": "f2a9",
	"./DAR.svg": "b4e5",
	"./DASH-alt.svg": "9d57",
	"./DASH.svg": "b9f9",
	"./DAT.svg": "1d42",
	"./DATA.svg": "c6d3",
	"./DBC.svg": "8283",
	"./DCC.svg": "17c6",
	"./DCN.svg": "1307",
	"./DCR-alt.svg": "2a08",
	"./DCR.svg": "b0a5",
	"./DCT-alt.svg": "aec9",
	"./DCT.svg": "bd3b",
	"./DEEZ.svg": "b387",
	"./DENT.svg": "64fe",
	"./DEW.svg": "fca0c",
	"./DGB-alt.svg": "84c0",
	"./DGB.svg": "804c",
	"./DGD.svg": "4362",
	"./DGTX.svg": "2606",
	"./DGX.svg": "806d",
	"./DHT.svg": "1b7b",
	"./DLT.svg": "b165",
	"./DMD-alt.svg": "c4e0",
	"./DMD.svg": "3d4f",
	"./DNR.svg": "8144",
	"./DNT.svg": "254d",
	"./DOCK.svg": "1e97",
	"./DOGE-alt.svg": "a72c",
	"./DOGE.svg": "c369",
	"./DRGN.svg": "5d7f",
	"./DROP.svg": "cb36",
	"./DSH.svg": "0b63",
	"./DTA.svg": "e510",
	"./DTH.svg": "ed7f",
	"./DTR.svg": "8976",
	"./EBST.svg": "7019",
	"./ECA.svg": "4dc6b",
	"./EDG.svg": "befe",
	"./EDO.svg": "9c3e",
	"./EDOGE.svg": "13535",
	"./EDU.svg": "1f0f",
	"./EKO.svg": "a6a5",
	"./ELA.svg": "c0fa",
	"./ELEC.svg": "7c0a",
	"./ELF.svg": "2979",
	"./ELIX.svg": "f1d9",
	"./ELLA.svg": "8dc8",
	"./EMC-alt.svg": "949d",
	"./EMC.svg": "d8a4",
	"./EMC2-alt.svg": "b915",
	"./EMC2.svg": "6068",
	"./ENG.svg": "f8e7",
	"./ENJ.svg": "c0c1",
	"./EOS-alt.svg": "6c707",
	"./EOS.svg": "3780",
	"./EQLI.svg": "a21c",
	"./EQUA.svg": "ab2c",
	"./ERC-alt.svg": "98d7",
	"./ERC.svg": "9e46",
	"./ETC-alt.svg": "3341",
	"./ETC.svg": "02fc",
	"./ETH-alt.svg": "925f",
	"./ETH.svg": "a1d4",
	"./ETHOS.svg": "0df1",
	"./ETN.svg": "ca95",
	"./ETP.svg": "5621",
	"./EUR.svg": "d1c5",
	"./EURS.svg": "2018",
	"./EVX.svg": "e161",
	"./EXMO.svg": "7746",
	"./EXP-alt.svg": "965f",
	"./EXP.svg": "632c",
	"./FAIR.svg": "c030",
	"./FC2-alt.svg": "b125",
	"./FC2.svg": "c482",
	"./FCN.svg": "5644",
	"./FCT-alt.svg": "6097",
	"./FCT.svg": "aa19",
	"./FIL.svg": "f71e",
	"./FJC.svg": "ff83",
	"./FLDC-alt.svg": "79b2",
	"./FLDC.svg": "a992",
	"./FLO-alt.svg": "1432",
	"./FLO.svg": "2a79",
	"./FRK-alt.svg": "a8b2",
	"./FRK.svg": "7d7d",
	"./FSN.svg": "2ae8",
	"./FTC-alt.svg": "6f1b",
	"./FTC.svg": "3388",
	"./FUEL.svg": "dd20",
	"./FUN.svg": "1624",
	"./GAME-alt.svg": "de52",
	"./GAME.svg": "cb82",
	"./GAS.svg": "55c96",
	"./GBG.svg": "db0b",
	"./GBP.svg": "9f2f",
	"./GBX.svg": "9ea5",
	"./GBYTE-alt.svg": "208f",
	"./GBYTE.svg": "bd1e",
	"./GDC-alt.svg": "b457",
	"./GDC.svg": "eaad",
	"./GEMZ-alt.svg": "9445",
	"./GEMZ.svg": "f39b",
	"./GENERIC.svg": "e5b8",
	"./GIFTO.svg": "9029",
	"./GLD-alt.svg": "be61",
	"./GLD.svg": "e2c7",
	"./GMR.svg": "3159",
	"./GNO-alt.svg": "ed9e",
	"./GNO.svg": "b9d6",
	"./GNT-alt.svg": "9d65",
	"./GNT.svg": "a187",
	"./GOLOS-alt.svg": "898a",
	"./GOLOS.svg": "56ea",
	"./GRC-alt.svg": "a36d",
	"./GRC.svg": "4f87",
	"./GRS.svg": "ff12",
	"./GSC.svg": "836b",
	"./GTO.svg": "42ed",
	"./GUP.svg": "a42e",
	"./GUSD.svg": "2571",
	"./GVT.svg": "3f8f",
	"./GXLT.svg": "84c0c",
	"./GXS.svg": "3c9a",
	"./GZR.svg": "778c",
	"./HEAT-alt.svg": "c86a",
	"./HEAT.svg": "0898",
	"./HIGHT.svg": "4345",
	"./HMQ.svg": "8672",
	"./HODL.svg": "b940",
	"./HPB.svg": "ed67",
	"./HSR.svg": "264c",
	"./HT.svg": "41db",
	"./HTML.svg": "45f7",
	"./HUC-alt.svg": "1612",
	"./HUC.svg": "238d",
	"./HUSH.svg": "a6df",
	"./ICN-alt.svg": "1e5b",
	"./ICN.svg": "c651",
	"./ICX.svg": "a058",
	"./IFC-alt.svg": "e271",
	"./IFC.svg": "1c02",
	"./IGNIS.svg": "de94",
	"./INCNT-alt.svg": "478c",
	"./INCNT.svg": "7413",
	"./INF.svg": "5a22",
	"./INK.svg": "feef",
	"./INS.svg": "97aa",
	"./IOC-alt.svg": "acb1",
	"./IOC.svg": "1888",
	"./ION.svg": "fc18",
	"./IOP.svg": "b549",
	"./IOST.svg": "6f83",
	"./IOTA-alt.svg": "e028",
	"./IOTA.svg": "5d24",
	"./IOTX.svg": "2681",
	"./ITC.svg": "70fa",
	"./JBS-alt.svg": "8c27",
	"./JBS.svg": "8b33",
	"./JNT.svg": "3021",
	"./JPY.svg": "a5c3",
	"./KCC.svg": "5300",
	"./KCS.svg": "07db",
	"./KIN.svg": "7033",
	"./KMD-alt.svg": "1881",
	"./KMD.svg": "7acb",
	"./KNC.svg": "070c",
	"./KOBO.svg": "e360",
	"./KORE-alt.svg": "6813",
	"./KORE.svg": "c243",
	"./KRB.svg": "d31c",
	"./LBA.svg": "1ad5",
	"./LBC-alt.svg": "38f3",
	"./LBC.svg": "5772",
	"./LDOGE-alt.svg": "032b",
	"./LDOGE.svg": "893e",
	"./LEND.svg": "d228",
	"./LINK.svg": "cb33",
	"./LKK.svg": "97d4",
	"./LOOM.svg": "2f90",
	"./LRC.svg": "c36b",
	"./LSK-alt.svg": "99bb",
	"./LSK.svg": "a5da",
	"./LTC-alt.svg": "4c40",
	"./LTC.svg": "09bd",
	"./LUN.svg": "fa3b",
	"./MAID-alt.svg": "6ce8",
	"./MAID.svg": "c563",
	"./MANA.svg": "5769",
	"./MARKS-alt.svg": "48fb",
	"./MARKS.svg": "723f",
	"./MAS (1).svg": "2ac0",
	"./MAS.svg": "36a4",
	"./MCAP.svg": "14a8",
	"./MCO-alt.svg": "ec3a",
	"./MCO.svg": "9660",
	"./MDA.svg": "80c9",
	"./MDS.svg": "8759",
	"./MED.svg": "c748",
	"./MINT-alt.svg": "255a",
	"./MINT.svg": "8739",
	"./MIOTA.svg": "5fac",
	"./MITH.svg": "af3a",
	"./MKR.svg": "321f",
	"./MLN.svg": "a00c",
	"./MNX.svg": "bfad",
	"./MNZ.svg": "4013",
	"./MOAC.svg": "238b",
	"./MOC.svg": "00ab",
	"./MOD.svg": "8940",
	"./MONA-alt.svg": "f8fd",
	"./MONA.svg": "50fc",
	"./MOT.svg": "69e1",
	"./MRC.svg": "ed5a",
	"./MSC-alt.svg": "292d",
	"./MSC.svg": "761f",
	"./MSR.svg": "a129",
	"./MTH.svg": "c9c2",
	"./MTL-alt.svg": "ddc5",
	"./MTL.svg": "9a9d",
	"./MTR-alt.svg": "5391",
	"./MTR.svg": "e9f8",
	"./MUE-alt.svg": "a7ee",
	"./MUE.svg": "ec90",
	"./MUSIC.svg": "936b",
	"./MYST-alt.svg": "7f54",
	"./MYST.svg": "ed5f",
	"./MZC.svg": "48ff",
	"./NANO.svg": "1eee",
	"./NAS.svg": "50ad",
	"./NAV-alt.svg": "1c027",
	"./NAV.svg": "c781",
	"./NBT.svg": "41f7",
	"./NCASH.svg": "85ac",
	"./NDZ.svg": "fbde",
	"./NEBL.svg": "b523",
	"./NEO-alt.svg": "f05b",
	"./NEO.svg": "224a",
	"./NEOS-alt.svg": "df50",
	"./NEOS.svg": "c22a",
	"./NEU-alt.svg": "2bdd",
	"./NEU.svg": "ef6a",
	"./NEXO.svg": "5384",
	"./NGC.svg": "3f12",
	"./NIM.svg": "b690",
	"./NIO.svg": "3af0",
	"./NLC2.svg": "6e66",
	"./NLG-alt.svg": "931a",
	"./NLG.svg": "d62a",
	"./NMC-alt.svg": "973b",
	"./NMC.svg": "5c39",
	"./NMR.svg": "afd2",
	"./NOAH.svg": "fcf7",
	"./NOTE-alt.svg": "7a87",
	"./NOTE.svg": "d61b",
	"./NPXS.svg": "ff50",
	"./NULS.svg": "c202",
	"./NVC-alt.svg": "309d",
	"./NVC.svg": "b67b",
	"./NXS.svg": "c8697",
	"./NXT-alt.svg": "1cc1",
	"./NXT.svg": "7fc6",
	"./OAX.svg": "bac3",
	"./OCN.svg": "cf91",
	"./OK-alt.svg": "96e9",
	"./OK.svg": "2e23",
	"./OMG-alt.svg": "e215",
	"./OMG.svg": "9e690",
	"./OMNI-alt.svg": "c530",
	"./OMNI.svg": "08c0",
	"./ONT.svg": "bbdb",
	"./OOT.svg": "003b",
	"./OPAL-alt.svg": "825e",
	"./OPAL.svg": "991d",
	"./OST.svg": "c57b",
	"./OX.svg": "a09e",
	"./PAL.svg": "7f52",
	"./PART-alt.svg": "f224",
	"./PART.svg": "3d53",
	"./PASC.svg": "355e",
	"./PASL.svg": "bc17",
	"./PAT.svg": "08fe",
	"./PAX.svg": "b6d1",
	"./PAY.svg": "1eea",
	"./PAYX.svg": "8289",
	"./PIGGY-alt.svg": "bbce",
	"./PIGGY.svg": "8ad1",
	"./PINK-alt.svg": "aac8",
	"./PINK.svg": "685f",
	"./PIRL.svg": "cb52",
	"./PIVX-alt.svg": "3bc4",
	"./PIVX.svg": "16b4",
	"./PLR.svg": "96e6",
	"./PMA.svg": "ffcd",
	"./POA.svg": "bdc5",
	"./POE.svg": "b47d",
	"./POLY.svg": "94e7",
	"./POT-alt.svg": "8655",
	"./POT.svg": "51e9",
	"./POWR.svg": "bd15",
	"./PPC-alt.svg": "f33f",
	"./PPC.svg": "ecc8",
	"./PPP.svg": "8eb1",
	"./PPT.svg": "5c26",
	"./PRL.svg": "94e5",
	"./PRO.svg": "fcfd",
	"./PROC.svg": "4694",
	"./PT.svg": "318d",
	"./PTOY.svg": "fe4c",
	"./PURA.svg": "6804",
	"./QASH.svg": "a9df",
	"./QCN.svg": "9323",
	"./QIWI.svg": "55eb",
	"./QKC.svg": "bbcb",
	"./QLC.svg": "790f",
	"./QRK-alt.svg": "c33f",
	"./QRK.svg": "7d88",
	"./QRL.svg": "ab1e",
	"./QSP.svg": "6c26",
	"./QTUM-alt.svg": "6e7c",
	"./QTUM.svg": "0d07",
	"./R.svg": "8d78",
	"./RADS-alt.svg": "9c4b",
	"./RADS.svg": "96b4",
	"./RAP.svg": "522f",
	"./RBIES-alt.svg": "c839",
	"./RBIES.svg": "09b8",
	"./RBT-alt.svg": "2a91",
	"./RBT.svg": "c3a5",
	"./RBY-alt.svg": "cae0",
	"./RBY.svg": "6075",
	"./RCN.svg": "eef6",
	"./RDD-alt.svg": "6701",
	"./RDD.svg": "791d",
	"./RDN.svg": "2b49",
	"./REN.svg": "6229",
	"./REP-alt.svg": "422d",
	"./REP.svg": "02e7",
	"./REQ.svg": "d945",
	"./RFR.svg": "1e5d",
	"./RHOC.svg": "3357",
	"./RIC-alt.svg": "e8e3",
	"./RIC.svg": "ece0",
	"./RISE-alt.svg": "b716",
	"./RISE.svg": "0b45f",
	"./RLC.svg": "4c87",
	"./ROP.svg": "9b50",
	"./RPX.svg": "4113",
	"./RUB.svg": "a7e2",
	"./RVN.svg": "92cd",
	"./SAFE.svg": "1a08",
	"./SALT-alt.svg": "148e",
	"./SALT.svg": "741e",
	"./SAN.svg": "3408",
	"./SAR-alt.svg": "db8c",
	"./SAR.svg": "36ef",
	"./SBD.svg": "339d",
	"./SBERBANK.svg": "ab0c",
	"./SC.svg": "33a3",
	"./SCOT-alt.svg": "5ff0",
	"./SCOT.svg": "6e95",
	"./SDC-alt.svg": "60df",
	"./SDC.svg": "43bd",
	"./SHIFT.svg": "3007",
	"./SIA-alt.svg": "2eb0",
	"./SIA.svg": "4d8a",
	"./SIB.svg": "f801",
	"./SJCX-alt.svg": "964b",
	"./SJCX.svg": "1610",
	"./SKIN.svg": "8d4e",
	"./SKY.svg": "7de8",
	"./SLG-alt.svg": "cd64",
	"./SLG.svg": "e389",
	"./SLR.svg": "c1d8",
	"./SLS-alt.svg": "afdd",
	"./SLS.svg": "1b18",
	"./SMART.svg": "6ec3",
	"./SNGLS.svg": "07ba",
	"./SNM.svg": "ba0c",
	"./SNRG-alt.svg": "ad49",
	"./SNRG.svg": "d1a5",
	"./SNT.svg": "e4ac",
	"./SOC.svg": "9ac2",
	"./SPANK.svg": "69ce",
	"./SPHTX.svg": "e7e9",
	"./SRN.svg": "cb99",
	"./SSP.svg": "fd9a",
	"./START-alt.svg": "66f7",
	"./START.svg": "bb45",
	"./STEEM-alt.svg": "aa44",
	"./STEEM.svg": "3ee5",
	"./STORJ.svg": "2e42",
	"./STORM.svg": "1485",
	"./STQ.svg": "9f43",
	"./STRAT-alt.svg": "1748",
	"./STRAT.svg": "3feb",
	"./STX.svg": "43eb",
	"./SUB.svg": "0463",
	"./SUMO.svg": "698f",
	"./SWIFT-alt.svg": "305a",
	"./SWIFT.svg": "bda1",
	"./SWT.svg": "493d",
	"./SYNC-alt.svg": "db85",
	"./SYNC.svg": "7dc6",
	"./SYS-alt.svg": "3506",
	"./SYS.svg": "f97c",
	"./TAAS.svg": "b1ac",
	"./TAU.svg": "63bd",
	"./TEL.svg": "cff5",
	"./TEN.svg": "1aa1",
	"./TERN.svg": "e683",
	"./THETA.svg": "1a5a",
	"./TIME.svg": "3707",
	"./TIX.svg": "07ff",
	"./TKN.svg": "86a4",
	"./TNB.svg": "2f10",
	"./TNC.svg": "03ed",
	"./TNT.svg": "13ad",
	"./TRIG-alt.svg": "a239",
	"./TRIG.svg": "4db3",
	"./TRST.svg": "82d0",
	"./TRTL.svg": "a65c",
	"./TRX.svg": "4483",
	"./TTC.svg": "d40e",
	"./TUSD.svg": "677d",
	"./TX-alt.svg": "5db7",
	"./TX.svg": "4593",
	"./TZC.svg": "f24c",
	"./UBQ-alt.svg": "7e47",
	"./UBQ.svg": "2ae6",
	"./UNITY-alt.svg": "31d1",
	"./UNITY.svg": "9569",
	"./USD.svg": "5f3d",
	"./USDC.svg": "b5eb",
	"./USDT-alt.svg": "e303",
	"./USDT.svg": "3e42",
	"./USNBT.svg": "1ac7",
	"./UTK.svg": "f24e",
	"./VEN.svg": "9ae0",
	"./VERI.svg": "afb1",
	"./VIA-alt.svg": "15f7",
	"./VIA.svg": "7678",
	"./VIB.svg": "3894",
	"./VIBE.svg": "32f6",
	"./VIOR-alt.svg": "1b8e",
	"./VIOR.svg": "046e",
	"./VIVO.svg": "7646",
	"./VNL-alt.svg": "46c6",
	"./VNL.svg": "a9d1",
	"./VPN-alt.svg": "170a",
	"./VPN.svg": "d036",
	"./VRC-alt.svg": "5823",
	"./VRC.svg": "3fe3",
	"./VRSC.svg": "9ef5",
	"./VTC-alt.svg": "d698",
	"./VTC.svg": "a1fe",
	"./WABI.svg": "964d",
	"./WAN.svg": "e1e0",
	"./WAVES-alt.svg": "4843",
	"./WAVES.svg": "954d",
	"./WAX.svg": "85ad",
	"./WBTC.svg": "6a76",
	"./WETH.svg": "7627",
	"./WGR.svg": "04a6",
	"./WICC.svg": "5fd3",
	"./WINGS.svg": "24a8",
	"./WPR.svg": "8476",
	"./WTC.svg": "2b2c",
	"./XAI-alt.svg": "9d00",
	"./XAI.svg": "745e",
	"./XAS.svg": "d58a",
	"./XAUR.svg": "d921",
	"./XBC.svg": "6074",
	"./XBS-alt.svg": "17c0",
	"./XBS.svg": "53f6",
	"./XBY.svg": "da51",
	"./XCP-alt.svg": "91c4",
	"./XCP.svg": "ed70",
	"./XDN.svg": "4e3d",
	"./XEM-alt.svg": "a85f",
	"./XEM.svg": "bab6",
	"./XIN.svg": "9b2a",
	"./XLM-alt.svg": "3d6e",
	"./XLM.svg": "ab24",
	"./XMG.svg": "6aa6",
	"./XMO.svg": "fd54",
	"./XMR.svg": "c4a4",
	"./XMY.svg": "f2cb",
	"./XP.svg": "039b",
	"./XPA.svg": "8564",
	"./XPM-alt.svg": "0d06",
	"./XPM.svg": "4f3d",
	"./XRP-alt.svg": "8fda",
	"./XRP.svg": "46ed",
	"./XSG.svg": "20c8",
	"./XTZ-alt.svg": "4bee",
	"./XTZ.svg": "92ad",
	"./XUC.svg": "d04d",
	"./XVC-alt.svg": "4ae6",
	"./XVC.svg": "7035",
	"./XVG-alt.svg": "d0f0",
	"./XVG.svg": "e873",
	"./XZC-alt.svg": "d576",
	"./XZC.svg": "1056",
	"./YBC-alt.svg": "0c96",
	"./YBC.svg": "36d7",
	"./YOYOW.svg": "df61",
	"./ZAP.svg": "f41f",
	"./ZCL.svg": "4e57",
	"./ZEC-alt.svg": "04ab",
	"./ZEC.svg": "d64d",
	"./ZEIT-alt.svg": "47dd",
	"./ZEIT.svg": "ba5e",
	"./ZEL.svg": "4ec2",
	"./ZEN.svg": "46ce",
	"./ZIL.svg": "112e",
	"./ZILLA.svg": "ca7a",
	"./ZRX-alt.svg": "2d0a",
	"./ZRX.svg": "ad45"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "64d7";